var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "activity-stage",
    class: {
      isMobileView: _vm.isMobile
    }
  }, [_c('div', {
    staticClass: "top-to-bottom-reveal-container block-container"
  }, _vm._l(_vm.currentRound.blocks, function (block) {
    return _c('div', {
      key: block.id,
      staticClass: "block",
      style: {
        height: ((100 / _vm.currentRound.blocks.length) + "%")
      },
      attrs: {
        "id": ("block-" + (block.id))
      }
    }, _vm._l(block.steps, function (step) {
      return _c('div', {
        key: step.id,
        staticClass: "block-paragraph"
      }, [_c('blinking-cursor-text', {
        attrs: {
          "text": _vm.currentRound.steps.find(function (_ref) {
            var id = _ref.id;
            return id === step.id;
          }).answer,
          "text-step": _vm.currentRound.steps.findIndex(function (_ref2) {
            var id = _ref2.id;
            return id === step.id;
          })
        }
      })], 1);
    }), 0);
  }), 0), _c('div', {
    attrs: {
      "id": "img-overlay"
    }
  }, [_c('div', {
    attrs: {
      "id": "img-container"
    }
  }, [_c('img', {
    attrs: {
      "id": "img",
      "src": _vm.getImageSrc()
    }
  })])]), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }